import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

// const data = [
//   { name: 'Item A', innerValue: 400, outerValue: 600 },
//  { name: 'Item B', innerValue: 300, outerValue: 500 },
//   { name: 'Item C', innerValue: 200, outerValue: 700 },
//   { name: 'Item D', innerValue: 500, outerValue: 900 },
//   { name: 'Item E', innerValue: 400, outerValue: 600 },
//   { name: 'Item F', innerValue: 300, outerValue: 500 },
//   { name: 'Item G', innerValue: 300, outerValue: 600 },
//   { name: 'Item H', innerValue: 400, outerValue: 500 },
// ];
const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', background: '#fff', padding: 10, border: "1px solid #ccc", borderRadius: "10px" }}>
            <div style={{fontSize:"12px", color:"#616161"}}>{`${payload[0]['payload']['name']}`}</div>
            {/* <div style={{fontSize:"12px", color:"hsla(0, 0%, 82%, 1)"}}>{`AOP: $${payload[0]['payload']['outerValue']}MN`}</div>
            <div style={{fontSize:"12px", color:"#33ABDA"}}>{`Savings: $${payload[0]['payload']['innerValue']}MN`}</div> */}

            <div style={{fontSize:"12px", color:"hsla(0, 0%, 82%, 1)"}}>
              {payload[0]['payload']['outerValue'] === 0.0000001 
                ? "AOP: -" 
                : `AOP: $${payload[0]['payload']['outerValue']}MN`}
            </div>
            <div style={{fontSize:"12px", color:"#33ABDA"}}>
              {payload[0]['payload']['innerValue'] === 0.0000001 
                ? "Savings: -" 
                : `Savings: $${payload[0]['payload']['innerValue']}MN`}
            </div>
        </div>
    );
  }
}
const CustomBar = (props) => {
  const { x, y, width, height, payload } = props;
  const { innerValue, outerValue } = payload;
  
  // Calculate inner bar dimensions based on its value relative to outer value
  const innerWidth = width * (innerValue / outerValue);
  
  // Calculate inner height (narrower than outer)
  const innerHeight = height * 0.35; // 60% of outer height
  const innerY = y + (height - innerHeight) / 2;
  
  // Label styling
  const labelStyle = {
    color: "#616161",
    fontFamily: "Inter",
    fontSize:  "14px",
    fontWeight: 400
  };
  const textWidth = width>innerWidth?width:innerWidth;
  return (
    <g>
      {/* Draw outer bar first (lower z-index) */}
      <rect x={x} y={y} width={width} height={height} fill="#BCBCBC" opacity={0.7} />
      
      {/* Draw inner bar second (higher z-index) */}
      <rect x={x} y={innerY} width={innerWidth} height={innerHeight} fill="#33ABDA" />
      
      {/* Add labels to the right of the bar */}
      <text x={x + textWidth + 5} y={y + height/2 - 7} style={labelStyle} fill="#616161" fontSize={14}>
        {outerValue === 0.0000001 ? "AOP -" : `AOP $${outerValue}MN`}
      </text>
      <text x={x + textWidth + 5} y={y + height/2 + 12} style={labelStyle}  fill="#616161" fontSize={14}>
        {innerValue === 0.0000001 ? "Savings -" : `Savings $${innerValue}MN`}
      </text>
    </g>
  );
};

function getMaxValueExcludingSpecific(data, skipValue = 0.0000001) {
  const allValues = data.flatMap(item => [
    item.innerValue !== skipValue ? item.innerValue : 0,
    item.outerValue !== skipValue ? item.outerValue : 0
  ]);
  
  const filteredValues = allValues.filter(val => val !== skipValue);
  let max = Math.max(...filteredValues);
  const roundUpToNearest5 = (value) => Math.ceil(value / 5) * 5
  if(max>=5) {
      max = roundUpToNearest5(max*1.2)
  }
  return max;
}
const generateTicks = (min, max) => {
  const step = max/5;
  let ticks = [];
  if(max>0){
    if(max>0.01) {
      for (let i = min; i <= max; i += step) {
        if(max>=5) {
            ticks.push(i);
        } else {
            ticks.push(i.toFixed(2));
        }
      }
    } else {
      return [0, max];
    }
      
  } else {
      ticks = [1,2,3,4,5];
  }
  return ticks;
};

const BulletChart = ({data}) => {
  const maxValue = getMaxValueExcludingSpecific(data);
  const yTicks = generateTicks(0, maxValue);
  let chartHeight = data.length<3?data.length * 120:data.length * 80;
  chartHeight = chartHeight<400?400:chartHeight;
  return (
    <div style={{ width: "100%", maxHeight: "385px", overflowY: "auto" }}>
    <div style={{ width: "100%", height: chartHeight }}>
    <ResponsiveContainer width="100%" height={chartHeight}>
        <BarChart
        layout="vertical"
        width={"100%"}  // Increased width to accommodate labels
        height={400}
        data={data}
        margin={{ top: 10, right: 140, left: 40, bottom: 5 }}  // Increased right margin
        >
        <CartesianGrid horizontal={false} vertical={true} stroke='#DFDFDF' />
        <XAxis type="number" axisLine={false} tickLine={false} domain={[0, maxValue]} ticks={yTicks} />
        <YAxis type="category" dataKey="name" axisLine={false} tickLine={false}/>
        <Tooltip cursor={false} content={<CustomTooltip />}/>
        <Bar dataKey="outerValue" shape={<CustomBar />} barSize={40} />
        </BarChart>
    </ResponsiveContainer>
    </div>
  </div>  
  );
};

export default BulletChart;
